<script lang="ts">
	import image from "../../../core/assets/icons/euFlag.svg?raw";
	import { getEuProjektPath } from "@core/schema/paths/getEuProjektPath.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./EuProjectSection.translations.json" with { type: "json" };
	import Formatted from "./common/Formatted.svelte";
	import Icon from "./common/Icon.svelte";
	import Link from "./common/Link.svelte";
	import TextWithIcon from "./common/TextWithIcon.svelte";
	import { ButtonVariant } from "./common/getButtonClass.js";

	const translate = getTranslate(translations);
	const { tenant } = getGlobalTemplateProps();
</script>

<section class="full-width bg-zms-grey grid-container">
	<div class="container-center flex flex-col gap-8 sm:gap-10 md:gap-12">
		<div class="flex flex-col items-center text-center max-w-3xl mx-auto">
			<h2 class="mb-6"><Formatted text={translate("heading")} /></h2>
			<p class="font-normal text-sm sm:text-base lg:text-lg/[1.4] mb-8 text-optical-black">
				<Formatted text={translate("description")} />
			</p>
			<Link href={getEuProjektPath(tenant)} variant={ButtonVariant.OutlinedWithIcon}>
				<TextWithIcon><Formatted text={translate("learnMore")} /></TextWithIcon>
			</Link>
		</div>
	</div>
</section>
